module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/recovery/Payment-Receipts/payment-receipts-grid/payment-receipts-grid.component.css
// module id = ./src/app/recovery/Payment-Receipts/payment-receipts-grid/payment-receipts-grid.component.css
// module chunks = main